import { render, staticRenderFns } from "./VrsteSudionika.vue?vue&type=template&id=74cbbf9b&scoped=true&"
import script from "./VrsteSudionika.vue?vue&type=script&lang=js&"
export * from "./VrsteSudionika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cbbf9b",
  null
  
)

export default component.exports